import { useCallback } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { Button } from '../../input/Button';
import { ContentPromotionPostsDialog } from '../ContentPromotionPostsDialog/ContentPromotionPostsDialog';
import { ContentPromotionPostsRadio } from './parts/ContentPromotionPostsRadio/ContentPromotionPostsRadio';
import { Wrapper } from './styles';
import { ContentPromotionPostsValue, type ContentPromotionPostsProps } from './types';

export const ContentPromotionPosts: React.FC<ContentPromotionPostsProps> = ({
    value,
    posts,
    disabledPosts,
    visiblePostsDialog,
    onClose,
    onSave,
    onChange,
    ...other
}) => {
    const isChoicePostsChecked = value === ContentPromotionPostsValue.CHOICE;

    const t = useTranslation();

    const onClickPostsButton = useCallback(() => {
        onChange(ContentPromotionPostsValue.CHOICE);
    }, [onChange]);

    return (
        <>
            <Wrapper onChange={onChange} {...other}>
                <ContentPromotionPostsRadio
                    title={t('Все посты')}
                    text={t('Все посты за последние 90 дней. Рекомендуемый вариант.')}
                    value={ContentPromotionPostsValue.ALL}
                    checked={value === ContentPromotionPostsValue.ALL}
                />
                <ContentPromotionPostsRadio
                    ml={{ xs: 0, sm: 2 }}
                    mt={{ xs: 2, sm: 0 }}
                    title={t('Новые посты')}
                    text={t('Все посты за последние 30 дней.')}
                    value={ContentPromotionPostsValue.NEW}
                    checked={value === ContentPromotionPostsValue.NEW}
                />
                <ContentPromotionPostsRadio
                    ml={{ xs: 0, sm: 2 }}
                    mt={{ xs: 2, sm: 0 }}
                    title={t('Выбрать посты')}
                    text={t('Можно исключить отдельные посты от продвижения.')}
                    value={ContentPromotionPostsValue.CHOICE}
                    checked={isChoicePostsChecked}
                >
                    {isChoicePostsChecked ? (
                        <Button size="m" mt={1} onClick={onClickPostsButton}>
                            {t('Выбранные посты')}
                        </Button>
                    ) : null}
                </ContentPromotionPostsRadio>
            </Wrapper>
            {visiblePostsDialog ? (
                <ContentPromotionPostsDialog
                    posts={posts}
                    disabledPosts={disabledPosts}
                    onClose={onClose}
                    onSave={onSave}
                />
            ) : null}
        </>
    );
};
